import { InteractaIcon } from '@interacta-shared/util';
import { ToastNotificationSourceType } from '@interacta-shared/util-common';

export const iconByType: Record<
    ToastNotificationSourceType,
    { icon: InteractaIcon; colorClass: string }
> = {
    triggerAutomation: {
        icon: 'flash-on-filled',
        colorClass: 'text-system-success',
    },
};
